import Styled from 'styled-components'

export const Container = Styled.div`
  .swiper-pagination-bullet{
    display: none !important;
  }
`

export const Img = Styled.img`
  width: 115px;
  height: 105px;
  object-fit: cover;  
  border-radius: 6px;
`

export const Span = Styled.span`
  weight: 500;
  display: block;
  cursor: pointer;
  text-align: center;
  margin-top: 7px;
  font-size: 16px;
  line-height: 150%;
  word-wrap: break-word;
  color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
  @media(max-width: 800px) {
    margin-top: 7px;
  }
`

/* Desktop (>=1024px): grid multi-coluna no lugar do carrossel */
export const DesktopGrid = Styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 28px 16px;

  @media (min-width: 1024px) and (max-width: 1199px) {
    grid-template-columns: repeat(5, 1fr);
  }

  .grid-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
`
